import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const Normalization = () => (
  <QPhototModuleSubtopic
    title="Normalization"
    videos={[
      "https://www.youtube.com/embed/xoTyrdT9SZI",
      "https://www.youtube.com/embed/mUtAPbb1ECM",
      "https://www.youtube.com/embed/R7UblSu4744",
      "https://www.youtube.com/embed/O16btnzfuYU",
      "https://www.youtube.com/embed/aAx_JoEDXQA",
      "https://www.youtube.com/embed/R2Z-DgZ6QFQ",
      "https://www.youtube.com/embed/NNjUhvvwOrk",
      "https://www.youtube.com/embed/nSnaGLtwgMc"
    ]}
    takeaways={[]}
    questions={[
      { text: "A relation ADDR is defined with attributes NAME (unique), STREET, CITY, STATE and POSTCODE for storing the customer address details. The functional dependencies of the relation are: POSTCODE → CITY, STATE; STREET, CITY, STATE → POSTCODE; NAME → STREET, CITY, STATE. Check if the given relation is in BCNF? 3NF? 2NF?" },
      { text: "Consider the pet health history report table given below and normalize it to 3NF.",
        image:"/dbms_17.png"
       },
      { text: "Consider the relation for published books. a) What normal form is the relation in? Explain your answer. b) Apply Normalization until you cannot decompose the relation further. State the reasons behind each decomposition.",
        image:"/dbms_18.png"
       },
      { text: "Consider the restaurant management relation mentioned below. This relation is used to store data about the restaurant's employees but has few design issues. Normalize it till 3NF.",
        image:"/dbms_19.png"
       },
      { text: "Examine the table shown below: (a) Why is this table not in 2NF? (b) Describe and illustrate the process of normalizing the data shown in this table to 3NF.",
        image:"/dbms_20.png"
       },
      { text: "Check R1 and R2 for BCNF, if not in BCNF convert them into BCNF: R1(elevator_no, building_no, capacity, building_name), R2(elevator_no, building_no, capacity). FD= {elevator_no -> building_no, capacity and building_no -> building_name}." },
      { text: "Consider the relation and functional dependencies: R=(A,B,C,D), F= {AB -> C, B -> D, C -> A} (i) What is/are the candidate keys? (ii) Is the given relation in BCNF? If not, decompose into BCNF. (iii) Is the decomposed relation preserving the functional dependencies? If no, list the FDs and state the reason." },
      { text: "Consider the relation R(P,Q,R,S,T,U,V,W,X,Y) with the set of FDs: PQ -> R, P -> ST, Q -> UV, U -> WX, S -> Y. Normalize the schema into 3NF. Provide resulting relations and explain the decomposition process for violations encountered." },
      { text: "Schema R = (B,O,I,S,Q,D) with FDs {I -> B, IS -> Q, B -> O, S -> D}. (i) List all candidate keys. (ii) List prime and non-prime attributes. (iii) Classify the normal form of R and justify. (iv) Identify FDs violating a normal form and perform lossless-join decomposition into subsequent normal forms up to BCNF." }
    ]}
    exampleVideos={[]}
  />
);

export default Normalization;
